import storage from "@/utils/storage";
import store from "@/store";
import Config from "@/config";

const state = {
    navPath: null,
    isValidRoute: false,

    isRouting: true,
    isFirstLoad: true,
    isSessionClosing: false,
    isTaskFullscreen: false,
    isTaskWithAIChat: false,
    withContextList: true,
    withArchivedGroups: false,
    withMessageBlockForced: false,
    withTaskDropZones: false,
    pendingGoalSwap: null,          // {processId, index} - swap цели процесса отправлен на backend и ещё не завершён (оптимистичный показ)
    draggedGoal: null,             // {id, contextId} цели процесса, которую сейчас перетаскивают (см. context-tasks.vue)
    withStageDropZones: false,
    isMsgEditorExpanded: false,
    isTaskEditorExpanded: false,
    aiImprovedContentIds: {},       // contentId -> true на ~1.3 с после успешного AI-улучшения (анимация в task-editor2)
    aiImprovingContentIds: {},      // contentId -> true, пока идёт AI-улучшение текста (редактор блокируется)
    withOpenSubtasks: false,
    withMaximizedComments: null,    // true = comments are maximized, false = editor is maximized, null = both are of same size
    isContext1TaskMode: false,
    isUserListMode: false,
    withHiddenTasks: false,
    // сколько абзацев текста открытой задачи помечено скрытыми (--hidden); считает редактор задачи (task-editor2)
    hiddenParagraphsCount: 0,
    // читаем сразу из storage: первый запрос контекста уходит до инициализации context-panel
    isUserContextTree: storage.getBoolean(Config.STORAGE_USER_CONTEXT_TREE) ?? false,
    // подзадачи контекста-задачи показываются текстом (пункты <li id> в редакторе), а не карточками;
    // режим хранится в sessionStorage - привязан к вкладке браузера
    isTextTaskList: storage.getSessionBoolean(Config.STORAGE_TEXT_TASK_LIST) ?? false,
    isAiChatDebugMode: false,
    //shouldSortTasks: true,
    isInited: false,
    visibleContextFilter: null,

    routingInstructions: {
        shouldMaximizeComments: false,
        shouldMinimizeComments: false,
        isOpeningNewTask: false,
    },

    error: {
        isVisible: false,
        title: null,
        message: null,
        code: null,
    },

    //dragged: null,

    search: {
        value: null,
        isSearching: false,
        withContexts: false,
        excludedTabs: [],
        includedTabs: [],
        filterGroupIds: null,
    },
    contextTasksFilter: {},

    taskMenu: {
        isVisible: false,
        item: null,
        callback: null,
        x: 0,
        y: 0,
    },
    aiChatMenu: {
        isVisible: false,
        callback: null,
        x: 0,
        y: 0,
        model: null,
        modelItems: null,
        effectiveModelTitle: null,
        isSavingModel: false,
        isResetting: false,
        onSelectModel: null,
        onReset: null,
    },
    taskSubtasksMenu: {
        isVisible: false,
        item: null,
        callback: null,
        x: 0,
        y: 0,
    },
    taskStageMenu: {
        isVisible: false,
        stageItem: null,
        callback: null,
        x: 0,
        y: 0,
    },

    prioMenu: {
        isVisible: false,
        item: null,
        siblings: null, // полный (нефильтрованный) список задач, среди которых находится item (для subButtons[].appliesTo)
        handler: null,  // called instead of general selection logic
        callback: null, // called after general selection logic
        prioOnly: false, // only show real prio options
        isSubcontent: false, // only show prios suitable for subcontent
        excludePrios: null, // значения prio, пункты которых не показываются в меню
        noSubButtons: false, // не показывать дополнительные кнопки пунктов (например, "наверх")
        // меню пункта текстового списка задач (редактор): пункты "Текст" и "Разделитель" между "Обычная" и "Заметка"
        withTextItems: false,
        isCheckParagraph: false, // абзац текста - устаревший чекбокс (--check): в меню добавляется выбранный пункт "Чекбокс"
        isTextParagraph: false, // меню обычного абзаца текста: item - виртуальный, все пункты обрабатывает handler
        onTextEntry: null, // вызывается с "text" | "hr" при выборе "Текст" / "Разделитель" (пункт-подзадача -> абзац / разделитель)
        owner: null, // кто открыл меню (uid компонента) - чтобы подсвечивать его кнопку, пока меню открыто
        x: 0,
        y: 0,
    },
    contextMenu: {
        isVisible: false,
        item: null,
        callback: null,
        x: 0,
        y: 0,
    },
    assigneeMenu: {
        isVisible: false,
        item: null,
        user: null, // todo why not item?
        callback: null,
        onUpdate: null, // fired for non-terminal updates (e.g. toggling "withController") without closing the menu
        x: 0,
        y: 0,
        users: null,
        title: null,
        preferredUsers: null,
        preferredTitle: null,
        usersOfGroup: null,
        excludeAuths: null,
        excludeIds: null,
        isUnpreffed: false,
        withUnsetEnabled: false,
        withController: false,
        //withControllerPick: false,
        //addController: false, // добавить новый пустой слот контролёра и сразу начать его заполнение, не трогая существующих
        //controllerIds: null, // existing controllerIds of the task - one .assignee-menu__control row is shown per id
    },
    assignmentMenu: {
        isVisible: false,
        item: null, // задача
        callback: null,
        x: 0,
        y: 0,
    },
    groupMenu: {
        isVisible: false,
        item: null,
        callback: null,
        x: 0,
        y: 0,
        items: null,
        title: null,
        preferredGroups: null,
        preferredTitle: null,
        excludeIds: null,
    },
    taskAccessMenu: {
        isVisible: false,
        item: null,
        callback: null,
        skipTitle: false,
        skipForbid: false,
        x: 0,
        y: 0,
    },
    groupSelector: {
        isVisible: false,
        item: null,
        items: null,
        callback: null,
        x: 0,
        y: 0,
    },
    taskSelector: {
        isVisible: false,
        value: null,
        callback: null,
        x: 0,
        y: 0,
    },
    topicSelector: {
        isVisible: false,
        item: null,
        items: null,
        callback: null,
        x: 0,
        y: 0,
    },
    valueSelector: {
        isVisible: false,
        item: null,
        items: null,
        withList: false,
        callback: null,
        x: 0,
        y: 0,
    },
    tagSelector: {
        isVisible: false,
        item: null,
        //favs: null,
        //value: null,
        withNewTag: false,
        withRemove: false,
        callback: null,
        x: 0,
        y: 0,
    },
    prioSelector: {
        isVisible: false,
        items: null,
        value: null,
        callback: null,
        x: 0,
        y: 0,
    },
    colorSelector: {
        isVisible: false,
        items: null,
        value: null,
        title: null,
        callback: null,
        x: 0,
        y: 0,
    },
    rangeSelector: {
        isVisible: false,
        value: null,
        //clearable: false,
        callback: null,
        x: 0,
        y: 0,
    },

    dialogCalendar: {
        isVisible: false,
        item: null,
        title: null,
        text: null,
        prop: null,
        clearLabel: null,
        callback: null,
    },
    dialogSelect: {
        isVisible: false,
        title: null,
        item: null,
        prop: null,
        options: null,
        callback: null,
    },
    dialogConfirm: {
        isVisible: false,
        isLoading: false,
        title: null,
        item: null,
        options: null,
        message: null,
        withHardConfirm: false,
        ok: null,
        isInfo: false,
        callback: null,
    },
    dialogTaskAccess: {
        isVisible: false,
        item: null,
        callback: null,
    },
    dialogTaskDone: {
        isVisible: false,
        item: null,
        callback: null,
    },
    dialogTaskDefer: {
        isVisible: false,
        item: null,
        callback: null,
    },
    dialogTaskDelay: {
        isVisible: false,
        item: null,
        title: null,
        texts: null,
        callback: null,
    },
    dialogTaskMove: {
        isVisible: false,
        items: null,
        contextId: null,
        fromContextId: null,
        place: false,
        excludedContextIds: null,
        callback: null,
    },
    dialogTaskTemplate: {
        isVisible: false,
        item: null,
        callback: null,
    },
    dialogInput: {
        isVisible: false,
        item: null,
        callback: null,
        title: null,
        placeholder: null,
        ok: null,
        prependIcon: null,
        appendIcon: null,
    },
    dialogInviteUsers: {
        isVisible: false,
        emails: null,
        groupIds: null,
    },
    dialogTaskMakeTopic: {
        isVisible: false,
        item: null,
        callback: null,
    },
    dialogTaskLinkThread: {
        isVisible: false,
        item: null,
        callback: null,
    },
    dialogUserEdit: {
        isVisible: false,
        item: null,
        callback: null,
    },
    dialogAuth: {
        isVisible: false,
        callback: null,
        zIndex: null,
    },
    dialogFilesViewer: {
        isVisible: false,
        files: null,
        index: null,
    },
    dialogCommentsViewer: {
        isVisible: false,
        parent: null,
        items: null,
        index: null,
    },
    dialogContextSelector: {
        isVisible: false,
        isLoading: false,
        withoutTags: false,
        item: null,
        callback: null,
    },
    dialogUser: {
        isVisible: false,
        isLoading: false,
        tabIndex: 0,
        callback: null,
    },
    dialogTags: {
        isVisible: false,
    },
    dialogPick: {
        isVisible: false,
        isLoading: false,
        item: null,
        callback: null,
    },
    dialogGroup: {
        isVisible: false,
        isLoading: false,
        item: null,
        tabIndex: 0,
        callback: null,
    },
    dialogGroupMerge: {
        isVisible: false,
        isLoading: false,
        item: null,
        groupId: null,
        tabIndex: 0,
        callback: null,
    },
    dialogTopic: {
        isVisible: false,
        isLoading: false,
        contextId: null,
        item: null,
        callback: null,
    },
    dialogFolder: {
        isVisible: false,
        isLoading: false,
        contextId: null,
        parentId: null,
        item: null,
        callback: null,
    },
    dialogAllDone: {
        isVisible: false,
        callback: null,
    },

    snack: {
        isVisible: false,
        text: null,
        html: null,
        route: null,
        action: null,
        actionLabel: null,
        icon: null,
        color: null,
        timeout: null,
        vertical: null,
        callback: null,
    },
    snack1TaskProcessed: {
        isVisible: false,
        item: null,
        text: null,
        color: null,
        callback: null,
        cancelCallback: null,
    },

    newTaskEditor: {
        text: null,
    },

    pending: {
        context: null,
        editor: null,
        tab: null,
        taskId: null,
    },

    mutations: {
        groupTaskSort: {
            timeout: null,
            userAuth: null,
        },
        taskGroup: {
            timeout: null,
            userAuth: null,
        },
        group: {
            timeout: null,
            subjectAuth: null,
            userAuth: null,
            icon: null,
        },
        task: {
            timeout: null,
            subjectAuth: null,
            userAuth: null,
            icon: null,
        },
    },
};

// init default values

const contextTasksFilter = storage.get(Config.STORAGE_CONTEXT_TASKS_FILTER);
//console.log("contextTasksFilter", contextTasksFilter);
if ( contextTasksFilter ) {
    Object.keys(contextTasksFilter).forEach(key => state.contextTasksFilter[key] = contextTasksFilter[key]);
}

export default state;
